import {
  jb_listing_css_default
} from "./chunk.2WMDFQZG.js";
import {
  Spaceable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.LK5OUX7S.js";
import {
  to
} from "./chunk.3OP6Y2IJ.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ChangesBackgroundColor
} from "./chunk.6ORGI2J5.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  e,
  n,
  r as r2
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-listing/jb-listing.ts
var JbListing = class extends ChangesBackgroundColor(Spaceable(r)) {
  constructor() {
    super(...arguments);
    this.type = "listing";
    this._expanded = false;
    this._filteredItems = [];
  }
  updated(_changedProperties) {
    super.updated(_changedProperties);
    this._hideButtonPanelIfNotNeeded();
    if (!_changedProperties.has("_filteredItems")) {
      this._refreshItemsList();
    }
  }
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    const filterButtons = this.renderRoot.querySelectorAll("jb-listing-filter");
    filterButtons.forEach((itm) => {
      this._setActiveFilter(itm.filterAspect, itm.activeValue);
    });
    this._filteredItems = this.items;
    if (this.type === "event") {
      this._updateItemsList(this._filteredItems);
      this._sortPastEvents(this._filteredItems);
      import("../components/jb-event-list-item/jb-event-list-item.js").then();
    }
    this._stripUselessFilters(this.filters);
    this._refreshItemsList();
    if (this.type === "news") {
      import("../components/jb-news-list-item/jb-news-list-item.js").then();
    }
  }
  _convertToDate(dateStr) {
    const [day, month, year] = dateStr.split(".").map(Number);
    return new Date(year, month - 1, day);
  }
  _countItemsMatchingFilters(filters) {
    const { length } = this._getMatchingItems(filters);
    return length;
  }
  _getActiveFilter(filterAspect) {
    const activeFilter = this.filters?.find((filter) => filter.filterAspect === filterAspect);
    return activeFilter.activeValue ? activeFilter.activeValue : activeFilter.options[0].value;
  }
  _getActiveFilters() {
    const activeFilters = /* @__PURE__ */ new Map();
    const possibleFilters = /* @__PURE__ */ new Map();
    this.items?.forEach((item) => {
      item.filterValues?.forEach((filterValue) => {
        possibleFilters.set(filterValue.filterAspect, filterValue.value);
      });
    });
    this.filters?.forEach((filter) => {
      let selectedValue = filter.activeValue;
      if (!selectedValue) {
        selectedValue = possibleFilters.get(filter.filterAspect) ?? Array.from(possibleFilters.values())[0];
      }
      activeFilters.set(filter.filterAspect, selectedValue);
    });
    return activeFilters;
  }
  _getContentSpacingProperties() {
    const type = this.headline ? "list" : "list-without-heading";
    const cols = this.variant === "narrow" ? 6 : void 0;
    return { colsMdUp: cols, type };
  }
  _getMatchingItems(filters) {
    if (this.items === null) {
      return void 0;
    }
    return this.items?.filter((item) => {
      let compliesWithAllFilters = true;
      [...filters.keys()].forEach((filterAspect) => {
        const value = filters.get(filterAspect);
        if (value === "" || value === "__all" || value === void 0) {
          return;
        }
        if (!this._matchesFilterValue(item, filterAspect, value)) {
          compliesWithAllFilters = false;
        }
      });
      return compliesWithAllFilters;
    });
  }
  _handleExpandButtonClick(event) {
    event.preventDefault();
    this._expanded = true;
  }
  _handleFilterChange(event) {
    this._setActiveFilter(event.detail.filterAspect, event.detail.newValue);
    this._expanded = false;
    this.requestUpdate();
  }
  _hideButtonPanelIfNotNeeded() {
    if (!this._buttonPanel) {
      return;
    }
    if (!this._buttonsSlot || !this._buttonsSlot.assignedElements().length) {
      this._buttonPanel.style.display = "none";
    } else {
      this._buttonPanel.style.removeProperty("display");
    }
  }
  _matchesFilterValue(item, filterAspect, value) {
    return !!item.filterValues?.find(
      (filterValue) => filterValue.filterAspect === filterAspect && filterValue.value === value
    );
  }
  _refreshItemsList() {
    if (this.items.length === 0) {
      return;
    }
    const matchingItems = this.filters === void 0 || this.filters.length === 0 ? this.items : this._getMatchingItems(this._getActiveFilters());
    const itemsToBeShown = this._expanded || !this.truncateAmount ? matchingItems : matchingItems.slice(0, this.truncateAmount);
    this._filteredItems = itemsToBeShown;
    if (matchingItems?.length > 0 && this.truncateAmount && !this._expanded && matchingItems?.length <= this.truncateAmount) {
      this._expanded = true;
    }
  }
  _setActiveFilter(filterAspect, value) {
    const matchingFilter = this.filters?.find((filter) => filter.filterAspect === filterAspect);
    if (!matchingFilter) {
      return;
    }
    matchingFilter.activeValue = value;
  }
  _showExpandButton() {
    if (!this.items || !this.showMoreLabel || !this.truncateAmount || this.truncateAmount < 1 || this._expanded) {
      return false;
    }
    return this.items.length > this.truncateAmount;
  }
  _sortPastEvents(items) {
    items.sort((a, b) => {
      if (a.filterValues[0].value === "past" && b.filterValues[0].value === "past") {
        return this._convertToDate(b.date).valueOf() - this._convertToDate(a.date).valueOf();
      }
      return 0;
    });
  }
  _stripUselessFilters(filters) {
    if (filters === void 0 || this.items.length === 0) {
      return void 0;
    }
    const usefulFilters = [];
    const actualParentFilters = /* @__PURE__ */ new Map();
    filters.forEach((filter) => {
      const usefulFilter = { ...filter };
      const usefulFilterOptions = [];
      filter.options.forEach((option) => {
        let optionIsUseful;
        if (option.value === "__all") {
          optionIsUseful = true;
        } else {
          const simulateFilters = new Map(JSON.parse(JSON.stringify(Array.from(actualParentFilters))));
          simulateFilters.set(filter.filterAspect, option.value);
          const filterOptionMatchCount = this._countItemsMatchingFilters(
            simulateFilters
          );
          optionIsUseful = !(filterOptionMatchCount === 0);
        }
        if (!optionIsUseful) {
          return;
        }
        usefulFilterOptions.push(option);
      });
      usefulFilter.options = usefulFilterOptions;
      actualParentFilters.set(filter.filterAspect, this._getActiveFilter(filter.filterAspect));
      if (usefulFilter.options.length < 1) {
        this._setActiveFilter(filter.filterAspect, void 0);
        return;
      }
      const activeUsefulOption = usefulFilter.options.find(
        (option) => option.value === this._getActiveFilter(filter.filterAspect)
      );
      if (!activeUsefulOption) {
        this._setActiveFilter(filter.filterAspect, usefulFilter.options[0].value);
      }
      usefulFilters.push(usefulFilter);
    });
    return usefulFilters;
  }
  _tracking(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "listing"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  _updateItemsList(items) {
    const currentDate = /* @__PURE__ */ new Date();
    items.forEach((item) => {
      let filterValue = "";
      const eventDate = this._convertToDate(item.date);
      if (eventDate < currentDate) {
        filterValue = "past";
        item.addToCalendarLabel = void 0;
        item.icsLink = void 0;
      } else {
        filterValue = "upcoming";
      }
      item.filterValues[0].value = filterValue;
    });
    items.sort((a, b) => this._convertToDate(a.date).valueOf() - this._convertToDate(b.date).valueOf());
  }
  render() {
    const effectiveFilters = this._stripUselessFilters(this.filters);
    return ke`
      <div class="listing">
        ${this.kicker ? ke`<div class="kicker"><p>${this.kicker}</p></div>` : D}
        ${this.headline && ke` <jb-section-headline
          .headline=${this.headline}
          .languageBadge=${this.languageBadge}
          class="${Rt({ center_md_down: !!(this.headlineAlign || this.kicker) })}"
        ></jb-section-headline>`}
        ${effectiveFilters ? ke`
              <div class="filters">
                ${effectiveFilters.map(
      (filter) => ke`<jb-listing-filter
                      @jb-listing-filter:change=${this._handleFilterChange}
                      .activeValue=${filter.activeValue || filter.options[0].value}
                      .filterAspect=${filter.filterAspect}
                      .options=${filter.options}
                    ></jb-listing-filter>`
    )}
              </div>
            ` : D}

        <div class="list">
          ${this._filteredItems && this.type === "news" ? this._filteredItems.map(
      (newsItem) => ke`
                  <jb-news-list-item
                    .date=${newsItem.date}
                    .filterValues=${newsItem.filterValues}
                    .link=${newsItem.link}
                    .newsTitle=${newsItem.newsTitle}
                    .languageLabel=${newsItem.languagesLabel}
                    .languages=${newsItem.languages}
                    @jb-link:clicked=${this._tracking}
                  ></jb-news-list-item>
                `
    ) : D}
          ${this._filteredItems && this.type === "listing" ? this._filteredItems.map(
      (listingItem) => ke`
                  <jb-listing-item
                    .date=${listingItem.date}
                    .file=${listingItem.file}
                    .text=${listingItem.text}
                    .link=${listingItem.link}
                    ?iconFirst=${listingItem.iconFirst}
                    @jb-link:clicked=${this._tracking}
                  ></jb-listing-item>
                `
    ) : D}
          ${this._filteredItems && this.type === "event" ? this._filteredItems.map(
      (eventItem) => ke`
                  <jb-event-list-item
                    .addToCalendarLabel=${eventItem.addToCalendarLabel}
                    .date=${eventItem.date}
                    .icsLink=${eventItem.icsLink}
                    .filterValues=${eventItem.filterValues}
                    .link=${eventItem.link}
                    .location=${eventItem.location}
                    .time=${eventItem.time}
                    .text=${eventItem.text}
                    @jb-link:clicked=${this._tracking}
                  ></jb-event-list-item>
                `
    ) : D}
        </div>
        ${this._showExpandButton() ? ke`
              <jb-button-panel .align=${"center"}>
                <jb-button-secondary
                  @click=${this._handleExpandButtonClick}
                  .link=${{ href: "#" }}
                  >${to(this.showMoreLabel)}</jb-button-secondary
                >
              </jb-button-panel>
            ` : D}
        <jb-button-panel data-buttons>
          <slot name="buttons"></slot>
        </jb-button-panel>
      </div>
    `;
  }
};
JbListing.styles = jb_listing_css_default;
__decorateClass([
  n({ type: Array })
], JbListing.prototype, "filters", 2);
__decorateClass([
  n()
], JbListing.prototype, "headline", 2);
__decorateClass([
  n()
], JbListing.prototype, "headlineAlign", 2);
__decorateClass([
  n({ type: Array })
], JbListing.prototype, "items", 2);
__decorateClass([
  n()
], JbListing.prototype, "kicker", 2);
__decorateClass([
  n()
], JbListing.prototype, "languageBadge", 2);
__decorateClass([
  n()
], JbListing.prototype, "showMoreLabel", 2);
__decorateClass([
  n({ type: Number })
], JbListing.prototype, "truncateAmount", 2);
__decorateClass([
  n()
], JbListing.prototype, "type", 2);
__decorateClass([
  n()
], JbListing.prototype, "variant", 2);
__decorateClass([
  e("jb-button-panel[data-buttons]")
], JbListing.prototype, "_buttonPanel", 2);
__decorateClass([
  e('slot[name="buttons"]')
], JbListing.prototype, "_buttonsSlot", 2);
__decorateClass([
  r2()
], JbListing.prototype, "_expanded", 2);
__decorateClass([
  r2()
], JbListing.prototype, "_filteredItems", 2);
JbListing = __decorateClass([
  customElement("jb-listing")
], JbListing);

export {
  JbListing
};
